import Splide from '@splidejs/splide';

( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.service-slider-hero__slider' ).length ) {
        $( '.service-slider-hero__slider' ).each( function( index, element ) {
          const slider = new Splide( element, {
            type: 'loop',
            gap: '2rem',
            perPage: 1,
            focus: 'center',
            perMove: 1,
            pagination: false,
            speed: 800,
          } );

          const backgrounds = [
            'bg-[var(--hex-codes-light-blue)]',
            'bg-[var(--hex-codes-light-green)]',
            'bg-[var(--hex-codes-light-orange)]',
          ];

          const $sliderEl = $( element );

          slider.on( 'move', function( newIndex ) {
            const bgIndex = newIndex % backgrounds.length;
            $sliderEl.removeClass( backgrounds.join( ' ' ) ).addClass( backgrounds[bgIndex] );
          } );

          slider.mount();

          $sliderEl.addClass( backgrounds[slider.index % backgrounds.length] );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'service-slider-hero', COMPONENT );
} )( app );
